<template>
  <b-modal
    ref="open-share-modal"
    title="Share Invoice"
    size="sm"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    @hide="closeModal"
  >
    <div v-show="!sent">
      <b-row class="pl-2 pr-2" v-show="shareInvoiceVia.both">
        <b-col
          md="6"
          :class="type == 'SMS' ? 'border-active' : 'border-inactive'"
          @click="type = 'SMS'"
        >
          <p>SMS</p>
        </b-col>
        <b-col
          md="6"
          :class="type != 'SMS' ? 'border-active' : 'border-inactive'"
          @click="type = 'E-mail'"
        >
          <p>E-Mail</p>
        </b-col>
      </b-row>
      <b-row :class="shareInvoiceVia.both ? 'mt-3' : null">
        <b-col md="12" v-show="type == 'SMS'">
          <label for="share-sms-invoice">Customer Phone Number</label>
          <b-form-input
            id="share-sms-invoice"
            placeholder="Enter your phone number"
            v-model="$v.mobile.$model"
            :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
            aria-describedby="share-phone-live-feedback"
            v-allow.number.phone
            autocomplete="off"
          />
          <b-form-invalid-feedback id="share-phone-live-feedback">
            <span
              v-text="
                `Phone number must be ${state.system.country_details.phone_digit} characters long.`
              "
            />
          </b-form-invalid-feedback>
        </b-col>
        <b-col md="12" v-show="type == 'E-mail'">
          <label for="share-email-invoice">Customer E-mail address</label>
          <b-form-input
            id="share-email-invoice"
            v-model="$v.email.$model"
            :state="$v.email.$dirty ? !$v.email.$error : null"
            aria-describedby="share-email-live-feedback"
            placeholder="Enter your E-mail address"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="share-phone-live-feedback">
            {{ email == "" ? "This field is required." : "Invalid Email" }}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="12">
          <b-button
            block
            variant="primary"
            :disabled="sendBtnDisable || $loading"
            @click="sendInvoice"
          >
            <span v-if="!$loading">Send</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-show="sent">
      <div class="step-2">
        <ul>
          <li>
            <img src="../assets/images/success.svg" alt />
          </li>
          <li>
            <p
              class="mb-4"
              v-text="
                `${
                  type == 'SMS' ? 'A' : 'An'
                } ${type} with the invoice has been sent to ${
                  type == 'SMS' ? mobile : email
                }`
              "
            />
          </li>
        </ul>
        <b-button
          class="float-right px-4"
          id="dismiss-invoice-sms"
          @click="closeModal('dismiss')"
          >Dismiss</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
export default {
  name: "share-invoice-modal",
  props: ["open", "custMob", "custEmail", "invoiceNo"],
  mixins: [validationMixin],
  data() {
    return {
      type: "SMS",
      mobile: "",
      email: "",
      sent: false,
      startMinLength: "zwingMinLength",
      startMaxLength: "zwingMaxLength",
      minLength: this.$store.state.system.country_details.phone_digit,
      maxLength: this.$store.state.system.country_details.phone_digit,
    };
  },
  watch: {
    open() {
      if (this.open) {
        this.sent = false;
        this.mobile = this.custMob;
        this.email =
          this.custEmail != undefined && this.custEmail != null
            ? this.custEmail
            : "";
        this.checkConfig();
        this.$refs["open-share-modal"].show();
      }
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    shareInvoiceVia() {
      let temp = { email: false, sms: false, both: false };
      temp.email =
        this.state.system.settings.share_invoice_via.allow_via_email.status == 1
          ? true
          : false;
      temp.sms =
        this.state.system.settings.share_invoice_via.allow_via_sms.status == 1
          ? true
          : false;
      temp.both = temp.sms && temp.email ? true : false;
      return temp;
    },
    sendBtnDisable() {
      let temp = true;
      if (this.type == "SMS" && this.mobile != "" && !this.$v.mobile.$error)
        temp = false;
      if (this.type == "E-mail" && this.email != "" && !this.$v.email.$error)
        temp = false;
      return temp;
    },
  },
  validations() {
    return {
      mobile: {
        required,
        [this.startMinLength]: minLength(this.minLength),
        [this.startMaxLength]: maxLength(this.maxLength),
      },
      email: {
        required,
        email,
      },
    };
  },
  methods: {
    checkConfig() {
      if (this.shareInvoiceVia.both) this.type = "SMS";
      else if (this.shareInvoiceVia.sms && !this.shareInvoiceVia.email)
        this.type = "SMS";
      else if (this.shareInvoiceVia.email && !this.shareInvoiceVia.sms)
        this.type = "E-mail";
    },
    sendInvoice() {
      if (this.type == "SMS") this.sendInvoiceSMS();
      else if (this.type == "E-mail") this.sendInvoiceMail();
    },
    sendInvoiceSMS() {
      this.$loading = true;
      let data = {
        invoice_id: this.invoiceNo,
        mobile: this.mobile,
      };
      this.$store
        .dispatch("billing/sendSMS", data)
        .then((res) => {
          if (res.data.status != "fail") this.sent = true;
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    sendInvoiceMail() {
      this.$loading = true;
      let data = { invoice_id: this.invoiceNo, email_id: this.email };
      this.$store
        .dispatch("billing/sendEmail", data)
        .then((res) => {
          if (res.data.status != "fail") this.sent = true;
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    closeModal(type) {
      this.$emit("close-modal-share");
      if (type == "dismiss") this.$refs["open-share-modal"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.border-inactive {
  cursor: pointer;
  border-bottom: 2px solid #c0c0c0;
  p {
    margin-bottom: 2px;
    color: #c0c0c0;
    text-align: center;
  }
}
.border-active {
  cursor: pointer;
  border-bottom: 3px solid #208ee0;
  p {
    color: #208ee0;
    margin-bottom: 2px;
    font-weight: 600;
    text-align: center;
  }
}
.step-2 ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}
.theme-dark .step-2 ul {
  li p {
    color: #c0c0c0;
  }
}
</style>
